import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CanDisable, mixinDisabled } from '@angular/material/core';

const ItemCardImageFit = {
  None: 'none',
  Contain: 'contain',
  Cover: 'cover',
  Fill: 'fill',
  ScaleDown: 'scale-down',

  Inherit: 'inherit',
  Inital: 'inital',
  Revert: 'revert',
  Unset: 'unset',
} as const;

export type ItemCardImageFit = typeof ItemCardImageFit[keyof typeof ItemCardImageFit];

export class ItemCardBase {}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const _ItemCardMixinBase = mixinDisabled(ItemCardBase);

@Component({
  selector: 'csl-item-card',
  templateUrl: './item-card.component.html',
  styleUrls: ['./item-card.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
})
export class ItemCardComponent extends _ItemCardMixinBase implements CanDisable {
  /**
   * Binds 'disabled' class if [disabled] property is 'true'.
   */
  @HostBinding('class.disabled')
  get disabledBinding(): string {
    return this.disabled ? '' : undefined;
  }

  @Input() imageFit: ItemCardImageFit = ItemCardImageFit.Fill;

  @Input() iconLink = '';
  @Input() title = '';
  @Input() description = '';

  @Input()
  get cleanable() {
    return this._cleanable;
  }
  set cleanable(value: BooleanInput) {
    this._cleanable = coerceBooleanProperty(value);
  }
  private _cleanable = false;

  @Output() selectClicked: EventEmitter<void> = new EventEmitter();
  @Output() cleaned: EventEmitter<void> = new EventEmitter();

  constructor() {
    super();
  }

  clean(): void {
    if (this.disabled) {
      return;
    }

    this.cleaned.emit();
  }

  click(): void {
    if (this.disabled) {
      return;
    }

    this.selectClicked.emit();
  }
}
